import type {
  BetType, Resolution, ResolveFn, RollResult, TableRules, TableState,
} from '../types.js';

export type ResolverMap = Partial<Record<BetType, ResolveFn>>;

export function resolveAll(
  state: TableState,
  roll: RollResult,
  rules: TableRules,
  resolvers: ResolverMap,
): Resolution[] {
  const out: Resolution[] = [];
  for (const b of state.bets) {
    if (!b.working) {
      out.push({ betId: b.id, outcome: 'continue', payout: 0 });
      continue;
    }
    const fn = resolvers[b.type];
    if (!fn) throw new Error(`no resolver for bet type "${b.type}"`);
    out.push(fn(b, roll, state, rules));
  }
  return out;
}
